import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Col, Container, Input, Row } from 'reactstrap'
import { Loader } from '../common'
class HierarchyComponent1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			apiDef: null,
			loading: true,
			items: null,
			addLength: 1,
			caseField: [],
		}
	}

	componentWillReceiveProps(nextProps) {
		let data = {}
		if (nextProps && nextProps.entity && nextProps.entity.entityValues && nextProps.entity.entityValues) data = nextProps.entity.entityValues
		else if (nextProps && nextProps.entity && nextProps.entity.refEntityList && nextProps.entity.refEntityList.CategoryHierarchy)
			data = nextProps.entity.refEntityList.CategoryHierarchy

		if (data && data.properties) {
			if (
				nextProps &&
				nextProps.entity &&
				nextProps.entity.refEntityList &&
				nextProps.entity.refEntityList.CaseField &&
				nextProps.entity.refEntityList.CaseField.rows
			) {
				this.mapCaseField(data, nextProps.entity.refEntityList.CaseField.rows)
			}

			this.setState({
				items: data,
				addLength: data.properties.length,
			})
		}

		this.setState({ loading: nextProps.entity.loading })
	}
	mapCaseField(data, caseField) {
		if (data && caseField) {
			data.properties &&
				data.properties.length > 0 &&
				data.properties.forEach((elem, idx) => {
					caseField &&
						caseField.length > 0 &&
						caseField.forEach((item, index) => {
							if (
								item.fieldProperties &&
								item.fieldProperties.options &&
								!item.fieldProperties.options.isStatic &&
								item.fieldProperties.options.apiUrl &&
								item.fieldProperties.options.apiUrl.includes(`eq ${elem.level}`)
							) {
								elem.caseField = item.fieldName
							}
						})
					return elem
				})
		}
		this.setState({ items: data })
	}
	componentWillMount() {
		const {
			meta: { appComponentMeta },
		} = this.props
		appComponentMeta &&
			appComponentMeta.staticContent &&
			appComponentMeta.staticContent.content &&
			this.setState({ apiDef: appComponentMeta.staticContent.content })
	}
	componentDidMount() {
		this.apiRequest()
	}

	apiRequest = async () => {
		const { apiDef } = this.state
		let { t } = this.props
		if (apiDef && apiDef.pop && apiDef.length > 0) {
			apiDef.forEach(async (items, idx) => {
				let filterItems =
					items.api &&
					items.api.method &&
					items.api.method === 'GET' &&
					items.api.filter &&
					items.api.filter.map(i => {
						let r = [i.value].reduce((p, c) => {
							return p[c]
						}, this.props.profile)
						if (r) i.value = r
						return i
					})
				items.api && items.api.method && items.api.method === 'GET' && (await this.props.getOne({ apiDef: items.api, filter: filterItems, t }))
			})
		}
		this.props.getRefItems({
			apiDef: { path: 'ticketing/CaseField/findAndCountAll', entityName: 'CaseField' },
			filter: [
				{ name: 'status', value: 'Published' },
				{ name: 'fieldProperties_type', value: 'select' },
			],
			t,
		})
	}

	handleChange(item, e) {
		const { items } = this.state
		item.label = e.target.value
		this.setState({
			items: { ...items, properties: [...items.properties] },
		})
	}

	addMore() {
		const { items } = this.state
		if (items && items.properties && Array.isArray(items.properties) && items.properties.length < 6) {
			let level = items.properties.length + 1
			let itemList = [...items.properties]
			let newItem = { name: `L${level}`, label: `Level-${level}`, level, status: 'Active', caseField: '' }
			itemList.push(newItem)

			this.setState({
				items: { ...items, properties: itemList },
				addLength: itemList.length,
			})
		}
	}
	filterPut = filterBy => {
		const { apiDef } = this.state
		return apiDef && apiDef.pop && apiDef.length > 0 && apiDef.find(x => x.name && x.name === filterBy)
	}
	upsert() {
		const { items } = this.state
		let { t } = this.props
		this.setState({ loading: true })
		let upsertDef = this.filterPut('CategoryHierarchyUpsert')
		if (upsertDef) {
			setTimeout(() => {
				this.props.upsertItem({ entityValues: items, t })
			}, 200)
		}
	}
	render() {
		const { t } = this.props
		const { items, addLength, loading, caseField } = this.state
		return (
			<div className="animated fadeIn">
				<div className="main-section">
					<div className="main-inner">
						<div className="common-heading">
							<div className="row table-title">
								<div className="col-sm-12">
									<div className="heading">
										<h5>{t('Category Hierarchy')}</h5>
									</div>
								</div>
							</div>
						</div>
						<section>
							{loading && <Loader />}
							<div className="row">
								<Container className="define-Hierarchy">
									{items &&
										items.properties &&
										Array.isArray(items.properties) &&
										items.properties.map((item, idx) => {
											return (
												<Row key={idx}>
													<Col>
														<div className={`padding-left-${idx}`}>
															<strong>{item.name}</strong>
														</div>
													</Col>

													<Col>
														<Input type="text" onChange={this.handleChange.bind(this, item)} name="itemLabel" value={t(item.label) || ''} />
													</Col>
													<Col>{t('Mapped Field')} : {t(item.caseField)}</Col>
												</Row>
											)
										})}
									{addLength && addLength < 6 && (
										<Button size="sm" color="link" onClick={this.addMore.bind(this)}>
											<i className="fa fa-plus"></i> {t('Add New Level')}
										</Button>
									)}

									<Button color="primary" size="sm" className="pull-right" onClick={this.upsert.bind(this)}>
										<i className="fa fa-edit"></i> {t('Update')}
									</Button>
								</Container>
							</div>
						</section>
					</div>
				</div>
			</div>
		)
	}
}
export const HierarchyComponent = withTranslation()(HierarchyComponent1)
